module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "summary-inner",
    staticStyle: {
      "left": "190px"
    }
  }, [_vm._l((_vm.summary), function(chapter) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isComponentPage),
        expression: "!isComponentPage"
      }],
      staticClass: "chapter",
      attrs: {
        "data-category": _vm.currentCategory
      }
    }, [_c('p', {
      staticClass: "chapter-title"
    }, [_vm._v(_vm._s(chapter.title))]), _c('ul', {
      staticClass: "chapter-page"
    }, _vm._l((chapter.pages), function(page) {
      return _c('li', {
        staticClass: "chapter-page-item"
      }, [_c('router-link', {
        attrs: {
          "to": _vm.getPath(page.path),
          "data-current-category": _vm.currentCategory
        }
      }, [_vm._v(_vm._s(page.title))])], 1)
    }))])
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Css')))]), _c('ul', {
    staticClass: "chapter-page"
  }, [_c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/css/1px.html")
    }
  }, [_vm._v(_vm._s(_vm.t('1px')))])], 1), _c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/css/close.html")
    }
  }, [_vm._v(_vm._s(_vm.t('css-close-icon')))])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Directives')))]), _c('ul', {
    staticClass: "chapter-page"
  }, [_c('li', {
    staticClass: "chapter-page-item"
  }, [_c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/directives/v-transfer-dom.html")
    }
  }, [_vm._v("v-transfer-dom")])], 1)])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComponentPage),
      expression: "isComponentPage"
    }],
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "chapter-title"
  }, [_vm._v(_vm._s(_vm.t('Toolkit')))]), _c('ul', {
    staticClass: "chapter-page"
  }, _vm._l((_vm.toolRoutes[_vm.lang]), function(route) {
    return _c('li', {
      staticClass: "chapter-page-item"
    }, [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_vm._v(_vm._s(_vm.t(route.title)))])], 1)
  }))]), _vm._l((_vm.categoryComponents), function(group) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isComponentPage),
        expression: "isComponentPage"
      }],
      staticClass: "chapter"
    }, [_c('p', {
      staticClass: "chapter-title"
    }, [_vm._v(_vm._s(group['category_' + _vm.lang]))]), _c('ul', {
      staticClass: "chapter-page"
    }, _vm._l((group.components), function(component) {
      return _c('li', {
        staticClass: "chapter-page-item component-list-item",
        attrs: {
          "id": ("component-list-item-" + (component.name))
        }
      }, [_c('router-link', {
        attrs: {
          "to": ("/" + _vm.lang + "/components/" + (component.name) + ".html")
        }
      }, [_vm._v(_vm._s(component.name))])], 1)
    }))])
  })], 2)]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header-nav"
  }, [_c('ul', {
    staticClass: "nav-list"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: _vm.$route.path === ("/" + _vm.lang + "/") || _vm.$route.path === ("/" + _vm.lang) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/"),
      "exact": true
    }
  }, [_vm._v(_vm._s(_vm.t('Guide')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: _vm.isComponentPage ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/components/actionsheet.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Components')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: /changelog/.test(_vm.$route.path) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/changelog/changelog.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Releases')))])], 1), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    class: /lab/.test(_vm.$route.path) ? 'link-active' : '',
    attrs: {
      "to": ("/" + _vm.lang + "/lab/index.html")
    }
  }, [_vm._v(_vm._s(_vm.t('Lab')))])], 1), (_vm.lang === 'zh-CN' && _vm.hide) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://cn.vuejs.org/v2/guide/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Vue 中文文档")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]) : _vm._e(), (_vm.lang === 'zh-CN' && _vm.hide) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://vuex.vuejs.org/zh-cn/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Vuex 中文文档")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]) : _vm._e(), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hide),
      expression: "hide"
    }],
    attrs: {
      "href": "/en/"
    }
  }, [_vm._v("English")]), _c('a', {
    on: {
      "click": _vm.switchLang
    }
  }, [_vm._v(_vm._s(/zh-CN/.test(_vm.$route.path) ? 'English(working)' : '中文'))])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Github")]), _c('svg', {
    staticStyle: {
      "vertical-align": "middle",
      "padding-left": "5px"
    },
    attrs: {
      "viewBox": "0 0 1024 1024",
      "width": "12",
      "height": "12"
    }
  }, [_c('defs'), _c('path', {
    attrs: {
      "d": "M864 640a32 32 0 0 1 64 0v224.096A63.936 63.936 0 0 1 864.096 928H159.904A63.936 63.936 0 0 1 96 864.096V159.904C96 124.608 124.64 96 159.904 96H384a32 32 0 0 1 0 64H192.064A31.904 31.904 0 0 0 160 192.064v639.872A31.904 31.904 0 0 0 192.064 864h639.872A31.904 31.904 0 0 0 864 831.936V640z m-485.184 52.48a31.84 31.84 0 0 1-45.12-0.128 31.808 31.808 0 0 1-0.128-45.12L815.04 166.048l-176.128 0.736a31.392 31.392 0 0 1-31.584-31.744 32.32 32.32 0 0 1 31.84-32l255.232-1.056a31.36 31.36 0 0 1 31.584 31.584L924.928 388.8a32.32 32.32 0 0 1-32 31.84 31.392 31.392 0 0 1-31.712-31.584l0.736-179.392L378.816 692.48z",
      "fill": "#333333",
      "p-id": "5014"
    }
  })])])]), _c('li', {
    staticClass: "search-item"
  }, [_c('algolia-search', {
    attrs: {
      "placeholder": _vm.t('Search documents'),
      "lang": _vm.lang,
      "emptyText": _vm.t('No search results')
    }
  })], 1)])]), _c('div', {
    staticClass: "markdown-body"
  }, [_c('router-view'), _c('div', [(/faq\//.test(_vm.$route.path) && /\.html/.test(_vm.$route.path)) ? _c('router-link', {
    attrs: {
      "to": ("/" + _vm.lang + "/faq/")
    }
  }, [_vm._v(" << " + _vm._s(_vm.t('return FAQ')))]) : _vm._e()], 1)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9e48fde0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-9e48fde0","preserveWhitespace":false}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 288
// module chunks = 483